module.exports = __webpack_public_path__ + "static/media/5.c5348a43.jpg";